import { Box, Button, Typography } from '@dtx-company/design-system/src'
import { FC, ReactNode } from 'react'
import { stopPropagationEvents } from '../LinkEditDrawer/LinkEditDrawer.utils'

export const MenuItem: FC<{
  label: string
  Icon: ReactNode
  onClick: () => void
  id?: string
  selected?: boolean
}> = ({ Icon, label, onClick, selected = false, id }) => {
  return (
    <Button
      variant="text"
      color={selected ? 'tertiary' : 'secondary'}
      onClick={onClick}
      id={id}
      {...stopPropagationEvents}
    >
      <Box
        component="span"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          rowGap: 2,
          color: 'inherit'
        }}
      >
        {Icon}
        <Typography variant="labelSmall" color={'inherit'}>
          {label}
        </Typography>
      </Box>
    </Button>
  )
}
